import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43d9dffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { class: "d-flex gap-10" }
const _hoisted_3 = { class: "borders" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Name", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "borders" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Phone", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "borders w-100 text-start mt-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Address", -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "d-flex gap-10 mt-5" }
const _hoisted_13 = { class: "borders" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Zipcode", -1))
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "borders" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Country", -1))
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "borders w-100 text-start mt-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Comment", -1))
const _hoisted_21 = { class: "content" }

import { ref, reactive } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetail',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {


const isSubmitting = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();

const hide = () => {
  modalRef.value?.hide();
};

const data = ref<any>({});

const show = async (_item: any) => {
  if (_item != null) {
    data.value = _item;
  }
  modalRef.value?.show();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Customer Detail",
    "is-loading": isSubmitting.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(data.value.customer.name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(data.value.customer.phone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(data.value.customer.address), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(data.value.customer.zipcode), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(data.value.customer.country), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(data.value.customer.comment), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})